import { apiClient } from './ApiClient';
export const deploymentsApi = {
    async getStatus(deploymentId) {
        const response = await apiClient.get(`/deployments/${deploymentId}`);
        return response.data.deployment;
    },
    async listForPrototype(prototypeId, options) {
        const params = new URLSearchParams();
        if (options?.status)
            params.append('status', options.status);
        if (options?.limit)
            params.append('limit', options.limit.toString());
        if (options?.offset)
            params.append('offset', options.offset.toString());
        const queryString = params.toString();
        const url = `/prototypes/${prototypeId}/deployments${queryString ? `?${queryString}` : ''}`;
        const response = await apiClient.get(url);
        return {
            deployments: response.data,
            total: response.pagination.total,
        };
    },
    async listAll(options) {
        const params = new URLSearchParams();
        if (options?.prototypeId)
            params.append('prototypeId', options.prototypeId);
        if (options?.status)
            params.append('status', options.status);
        if (options?.limit)
            params.append('limit', options.limit.toString());
        if (options?.offset)
            params.append('offset', options.offset.toString());
        const queryString = params.toString();
        const url = `/deployments${queryString ? `?${queryString}` : ''}`;
        const response = await apiClient.get(url);
        return {
            deployments: response.data,
            total: response.pagination.total,
        };
    },
};
